import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ContactListItem, SelectionEvent } from './contact-list.model';

@Component({
  selector: 'miq-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
  standalone: false,
})
export class ContactListComponent {
  @Input() inputLabel = '';
  @Input() contactList: ContactListItem[] = [];
  @Input() searchControl: UntypedFormControl;

  @Output() selectionChange = new EventEmitter<SelectionEvent>();

  public onSelectionChange(element: SelectionEvent) {
    this.selectionChange.emit(element);
  }
}
